// ui

export const uiCartIconIsShowingOrderInfo = state => {
  return state.cartIconIsShowingOrderInfo;
};

export const uiFullScreenLoading = state => {
  return state.fullScreenLoading;
};

// dialogs
export const showForgotPasswordDialog = state => {
  return state.dialogs.showForgotPasswordDialog;
};

export const showAddChildrenToOrderDialog = state => {
  return state.dialogs.showAddChildrenToOrderDialog !== false;
};

export const showAddChildrenToOrderDialogParams = state => {
  return state.dialogs.showAddChildrenToOrderDialog;
};

// help

export const getSupportUrl = state => {
  if (typeof state.config.help.setting_use_custom_help_system === "undefined")
    return null;
  if (state.config.help.setting_use_custom_help_system === false) {
    return "http://yearbookparentsupport.mementopix.com/support/solutions/folders/12000014243";
  } else {
    if (state.config.help.setting_help_knowledge_base_url) {
      return state.config.help.setting_help_knowledge_base_url;
    }
  }
};
